import { Routes } from '@angular/router';
import { appRoutes } from './shared/app-routes';

const route: Routes = [];
export const routes: Routes = route.concat(...appRoutes);
